/* ZGenericFunct
Versione 1.8.6 - 24 Gennaio 2025 - Massimiliano Zirilli
               - NEW: Inserita funzione per la sanitizzazione dei caratteri UNICODE per conversione JSON
Versione 1.7.6 - 25 Settembre 2024 - Mauro Brasile
               - FIX: Inserito lo static alla funzione ComparaOggetti
Versione 1.7.5 - 17 Settembre 2024 - Simone Biancolilla
               - NEW: Aggiunta la funzione ComparaOggetti
Versione 1.6.5 - 17 Settembre 2024 - Simone Biancolilla
               - FIX: Risolto bug GetHexColorFromRGB
Versione 1.6.4 - 18 Giugno 2024 - Mauro Brasile
               - NEW: Aggiunta funzione GenerateRandomColor
Versione 1.5.4 - 23 Aprile 2024 - Francesco Ardini
               - NEW: Aggiunta funzione per convertire il colore da rgb() a hex
Versione 1.4.4 - 22 Marzo 2024 - Mauro Brasile
               - NEW: Nella change url parameter adesso può essere passato l'url da gestire
Versione 1.3.4 - 07 Marzo 2024 - Francesco Ardini
               - FIX: Altro bug nella procedura che copia un oggetto
Versione 1.3.3 - 19 Febbraio 2024 - Mauro Brasile
               - FIX: Risolto bug nella copia di un array nella GetCopyOfObject
Versione 1.3.2 - 15 Febbraio 2024 - Mauro Brasile
               - FIX: Migliorata la GetCopyOfObject: se una proprietà dell'oggetto era uguale a null, la sostituiva con un oggetto vuoto
Versione 1.3.1 - 10 Novembre 2023 - Francesco Ardini
               - CHG: Migliorata la GetCopyOfObject
Versione 1.2.1 - 29 Settembre 2023 - Mauro Brasile
               - FIX: Migliorata la GetCopyOfObject, se nell'oggetto sono presenti 
                      altri oggetti effettua una copia anche di essi
Versione 1.2.0 - 28 Settembre 2023 - Mauro Brasile
               - NEW: Introdotta funzione GetCopyOfObject
Versione 1.1.0 - 25 Gennaio 2023 - Francesco Ardini
               - NEW: Introdotta funzione IsClientMobile
Versione 1.0.0 - 06 Agosto 2022 - Massimiliano  Zirilli
               - Prima versione
*/

export class TZGenericFunct
{
   static SanitizeObjectUnicode(obj) 
   {
      var escapeUnicode = function(str) 
      {
         return str.replace(/[\u007F-\uFFFF]/g, (char) => { return '\\u' + char.charCodeAt(0).toString(16).padStart(4, '0'); });
      }
   
      for (let key in obj) 
      {
          if (typeof obj[key] === 'string') 
              obj[key] = escapeUnicode(obj[key]);
          else 
          {
             if (typeof obj[key] === 'object' && obj[key] !== null) 
                this.SanitizeObjectUnicode(obj[key]); 
          }
      }
      return obj;
   }

   static XOR(a,b)
   {
     return ( a && !b ) || ( !a && b );
   }

   static IsClientMobile()
   { 
     var Answer = false;
     Answer = (/Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Windows Phone/i.test(navigator.userAgent)) ? true : false;
     return Answer;
   }

   static ChangeURLParameters(Parameters, UrlPassato)
   {
     var URL = UrlPassato != undefined? UrlPassato : window.location.href.split('?')[0];
     var First = true;
     for(var k in Parameters) 
     {
        URL += (First ? '?' : '&') + k + (Parameters[k] == null ? '' : '=' + Parameters[k]);
        First = false;
     }
     window.location.href = URL;
   }
  
   static GetURLParameters()
   {
     var Result = {}
     var Parameters = window.location.href.split('?')
     if(Parameters.length > 1)
     {
        Parameters = Parameters[1].split('&');
        Parameters.forEach(function(AParameter)
        {
          AParameter = AParameter.split('=') 
          Result[AParameter[0]] = AParameter.length > 1 ? AParameter[1] : null
        })
     }
     return Result
   }

   static GetCopyOfObject(Sorgente,Elemento)
   {
      Elemento = (Elemento == undefined || Elemento == null) ?  {} : Elemento;

      if(typeof Elemento !== 'object' || Array.isArray(Elemento))
        throw new Error('Il parametro elemento non è un oggetto')
      if(typeof Sorgente !== 'object' || Array.isArray(Sorgente))
        throw new Error('Il parametro sorgente non è un oggetto')

      var HandleArray = (VettoreSorgente,VettoreDestinazione) =>
      {
        for(var i = 0; i < VettoreSorgente.length;i++)
        {
          if(Array.isArray(VettoreSorgente[i]))
          {
            if(!Array.isArray(VettoreDestinazione[i]))
                VettoreDestinazione[i] = []
            HandleArray(VettoreSorgente[i],VettoreDestinazione[i])  
          }
          else
          {
            if(typeof VettoreSorgente[i] === 'object')
            {
              if(typeof VettoreDestinazione[i] !== 'object' || Array.isArray(VettoreDestinazione[i]))
              {
                  if(VettoreSorgente[i] != null)
                     VettoreDestinazione[i] = {}
                  else VettoreDestinazione[i] = null;
              }
              this.GetCopyOfObject(VettoreSorgente[i],VettoreDestinazione[i])
            }
            else VettoreDestinazione[i] = VettoreSorgente[i]
          }
        }
      }

      for(var PropertyName in Sorgente) 
      {
        if (PropertyName.substring(0, 2) != '__')
        {
          if(Array.isArray(Sorgente[PropertyName]))
          {
            if(!Array.isArray(Elemento[PropertyName]))
                Elemento[PropertyName] = []
            HandleArray(Sorgente[PropertyName],Elemento[PropertyName])
          }
          else
          {
            if(typeof Sorgente[PropertyName] === 'object')
            {
              if(typeof Elemento[PropertyName] !== 'object' || Array.isArray(Elemento[PropertyName]))
              {
                if(Sorgente[PropertyName] != null)
                   Elemento[PropertyName] = {}
                else Elemento[PropertyName] = null
              }
              this.GetCopyOfObject(Sorgente[PropertyName],Elemento[PropertyName])
            }
            else Elemento[PropertyName] = Sorgente[PropertyName]
          }
        }
      }
      return Elemento;
   }

   static ComparaOggetti(Oggetto1, Oggetto2)
   {
      var Cambiamenti = {};

      const SetChiavi = new Set([...Object.keys(Oggetto1), ...Object.keys(Oggetto2)]);

      SetChiavi.forEach(function(Chiave)
      {
        if(Oggetto1[Chiave] !== Oggetto2[Chiave] && typeof Oggetto1[Chiave] != 'object')
        {
        Cambiamenti[Chiave] = {
                    ValoreNuovo  : Oggetto1[Chiave],
                    ValoreVecchio: Oggetto2[Chiave]
                    };
        }
      });

      return Cambiamenti;
   }

   static GetHexColorFromRGB(RGB)
   {
      let Text = RGB.substring(4)
      let TextArray = Text.split(' ')
      let R = parseInt(TextArray[0])
      let G = parseInt(TextArray[1])
      let B = parseInt(TextArray[2])

      R = R.toString(16);
      G = G.toString(16);
      B = B.toString(16);

      if(R.length == 1)
        R = '0' + R;
      if(G.length == 1)
        G = '0' + G;
      if(B.length == 1)
        B = '0' + B;

      return '#' + R + G + B;
   }

   static GenerateRandomColor(VettoreColoriNonRichiesti)
   {
     if(VettoreColoriNonRichiesti == undefined)
      VettoreColoriNonRichiesti = []

      let Letters = '0123456789ABCDEF';
      let Color = '#';
      for (var i = 0; i < 6; i++) 
        Color += Letters[Math.floor(Math.random() * 16)];
      
      if(!VettoreColoriNonRichiesti.includes(Color))
         return Color
      else this.GenerateRandomColor(VettoreColoriNonRichiesti)
   }
}